import lodash from 'lodash'
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'

import Badge from '../../../../../../1stlog-ui/src/components/Badge'
import {
  FieldPrefix,
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import TimeBlock from './TimeBlock'

const Wrapper = styled.div``

const ProductSummary = (props) => {
  const { product, isPickup } = props

  const date = useField('date')

  if (!product) {
    return <></>
  }
  const {
    id,
    slaType,
    disabled,
    isExternal,
    provider,
    pickupType,
    deliveryType,
    avisTime,
    pickupFromTime,
    pickupUntilTime,
    deliveryFromTime,
    deliveryUntilTime,
    isDispositionProduct,
    timings,
    isManualDisposition,
    timeWindow,
  } = product

  const deliveryTimeString = deliveryFromTime
    ? moment(deliveryFromTime).format('DD.MM.YYYY')
    : i18n.t('unknown', 'Unbekannt')
  const pickupTimeString = pickupUntilTime
    ? moment(pickupUntilTime).format('DD.MM.YYYY')
    : i18n.t('unknown', 'Unbekannt')

  return (
    <Wrapper>
      <h4>
        {lodash.get(product, 'name', i18n.t('unknown', 'Unbekannt'))}{' '}
        {!isDispositionProduct && (
          <span>
            (
            {lodash.get(product, 'shortcode', '') !== ''
              ? lodash.get(product, 'shortcode', '?')
              : lodash.get(product, 'slaType', '?')}
            )
          </span>
        )}
        {isExternal ? (
          <span style={{ fontSize: '0.85em' }}>
            {' '}
            <Badge>Durchgeführt von {provider}</Badge>
          </span>
        ) : null}
      </h4>
      {!isDispositionProduct && (
        <div className="mt-1 mb-1">
          {isPickup
            ? 'Anlieferung bis'
            : i18n.t('delivery_from', 'Zustellung ab')}{' '}
          <strong>{isPickup ? pickupTimeString : deliveryTimeString}</strong>
        </div>
      )}
      {isManualDisposition && (
        <div className="mt-1 mb-1">
          <div style={{ whiteSpace: 'nowrap' }}>
            {i18n.t(`between`, `Zwischen`)}{' '}
            <strong>
              {moment(lodash.get(timeWindow, 'start')).format('HH:mm')}
              <span>-</span>
              {moment(lodash.get(timeWindow, 'end')).format('HH:mm')}
            </strong>
          </div>
        </div>
      )}
      {!isDispositionProduct && (
        <div className="d-flex">
          <div className="d-flex">
            <div style={{ flex: '1 1 0' }}>
              <FieldPrefix prefix="pickupTime">
                <TimeBlock
                  product={product}
                  isPickup
                  isPickupProduct={isPickup}
                />
              </FieldPrefix>
            </div>
            <div style={{ flex: '1 1 0' }}>
              <FieldPrefix prefix="deliveryTime">
                <TimeBlock product={product} isPickupProduct={isPickup} />
              </FieldPrefix>
            </div>
          </div>
        </div>
      )}
    </Wrapper>
  )
}

export default ProductSummary
